import { Button, DialogActions, Grid, Typography } from "@mui/material";
import { useState } from "react";
import Input from "../../../../../components/inputs/input";
import Modal from "../../../../../components/modal";

const ChangePriceModal = ({ currency, item, onClose, onChange }) => {
    const [unitPrice, setUnitPrice] = useState(item.unitPrice);

    const changePrice = (value) => {
        setUnitPrice(parseFloat(value));
    }

    return (
        <Modal
            open
            disableEnforceFocus
            disableAutoFocus
            disableEscapeKeyDown
            customButtons={() => (
                <DialogActions>
                    <Button
color="primary" 
                        onClick={() => onChange(item, parseFloat(unitPrice.toFixed(2)))} 
                        disabled={!(unitPrice > 0 && item.unitPrice !== unitPrice)}
                    >
                        Cambiar
                    </Button>
                    <Button color="primary" onClick={onClose}>
                        Cancelar
                    </Button>
                </DialogActions>
            )}
        >
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography variant="h5">
                        Cambio de precio unitario
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography>
                        Ingrese el precio para <strong>{item.refId}</strong> ({item.description})
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Input
                        autoFocus
                        fullWidth
                        size='small'
                        name='quantity'
                        label='Precio unitario'
                        step='0.01'
                        precision={3} 
                        onChange={(event) => changePrice(event.target.value)}
                        value={unitPrice}
                        type='number'
                    >
                    </Input>
                </Grid>
                <Grid size={12}>
                    <Typography>
                        <strong>Valor actual:</strong> {currency} {item.unitPrice.toFixed(2)}
                    </Typography>
                    <Typography>
                        <strong>Valor nuevo:</strong> {currency} {unitPrice.toFixed(2)}
                    </Typography>
                </Grid>
            </Grid>
        </Modal>
    );
}

export default ChangePriceModal;